module.exports = __webpack_public_path__ + "static/img/logo@2xht.8b3c3960.png";